import SensitiveContentWarning from './sensitive-content-warning'
export default SensitiveContentWarning
